import types from '../mutation-types';
import CallAPI from '../../api/call';

export const state = {
  settings: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
    isDeleting: false
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getSettings(_state) {
    return _state.settings;
  }
};

export const actions = {
  getSettings: async ({ commit }, params) => {
    commit(types.SET_CALL_UI_FLAG, { isFetching: true });
    commit(types.SET_CALL_SETTINGS, {});

    try {
      const { inboxId } = params;
      const response = await CallAPI.getSettings(inboxId);

      commit(types.SET_CALL_SETTINGS, response.data.calling);
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_CALL_UI_FLAG, { isFetching: false });
    }
  },
  updateSettings: async ({ commit }, { inboxId, payload }) => {
    commit(types.SET_CALL_UI_FLAG, { isUpdating: true });

    try {
      const response = await CallAPI.updateSettings(inboxId, payload);

      commit(types.SET_CALL_SETTINGS, response.data.calling);
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_CALL_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_CALL_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_CALL_SETTINGS](_state, records) {
    _state.settings = records;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
